/** Lane volume & rate trend: lanes with the biggest volume or rate moves. */
import type { LaneTrendPayload } from "@/types/feed";

import { laneBookingsHref } from "../../feedLinks";
import { compareScale, formatDeltaPct } from "../formatInsight";
import { explainerFor, periodLabel } from "../insightCopy";
import { ChangeRow, EntitySection, InsightShell, PeriodBanner } from "../primitives";

export function LaneTrendView({ payload }: { payload: LaneTrendPayload }) {
  const swings = payload.top_lane_swings ?? [];
  const period = periodLabel(payload as unknown as Record<string, unknown>);
  const max = compareScale(swings.flatMap((s) => [s.prior_teu, s.current_teu]));

  return (
    <InsightShell explainer={explainerFor(payload as unknown as Record<string, unknown>)}>
      {period && <PeriodBanner label={period} />}
      {swings.length > 0 && (
        <EntitySection title="Lane moves">
          {swings.map((s) => {
            const delta = formatDeltaPct(s.teu_pct_change);
            const rate =
              s.rate_pct_change !== 0
                ? `rate ${formatDeltaPct(s.rate_pct_change).text}`
                : undefined;
            return (
              <ChangeRow
                key={s.lane_key}
                name={s.lane_key}
                lane
                href={laneBookingsHref(s.lane_key)}
                primary={delta.text}
                primaryClassName={delta.className}
                subtitle={rate}
                deltaPct={s.teu_pct_change}
                bar={{
                  type: "compare",
                  prior: s.prior_teu,
                  current: s.current_teu,
                  unit: "TEU",
                  max,
                }}
              />
            );
          })}
        </EntitySection>
      )}
    </InsightShell>
  );
}
